import { Auth } from 'school-space-client/components';
import { getSchool } from 'school-space-client/api';

import { analytics, api, errorHandler } from '../services';

class AuthHandler extends Auth {
    constructor() {
        const {
            REACT_APP_AUTH0_DOMAIN: domain,
            REACT_APP_AUTH0_CLIENT_ID: clientID,
            REACT_APP_AUTH0_TENANCY: tenancy,
            REACT_APP_BASE_URL: baseUrl
        } = process.env;
        const auth0Config = {
            domain,
            clientID,
            tenancy,
            realm: 'School-Username-Password-Authentication'
        };

        super(auth0Config, baseUrl);
    }

    setApiToken(idToken) {
        api.setToken(idToken);
    }

    async fetchUser(idTokenPayload) {
        const schoolId = idTokenPayload['https://school-space.org/entity_id'];
        const { id, name, sites, spaces } = await getSchool(schoolId);

        this.setUser({
            id,
            email: idTokenPayload.email,
            name,
            sites,
            spaces
        });

        analytics.set({ userId: id });
        errorHandler.setUser(id);
    }
}

export default new AuthHandler();
